/* eslint-disable jsx-a11y/anchor-is-valid */
import {FC, useEffect, useState} from 'react'
import {StepProps, ICreateAppData} from '../IAppModels'
import CustomCalendar from '../../../../../_metronic/layout/calendar'
import {IPatientData} from '@/_metronic/partials/interface/IPatientData'
import {KTIcon} from '../../../../../_metronic/helpers'

const Step6: FC<StepProps> = ({
  data,
  updateData,
  hasError,
  handleStep2ValidationSuccess,
  handleStep2ValidationError,
  handleStep6ValidationSuccess,
  handleStep6ValidationError,
  errorMessageProduct,
  errorMessageBenefit,
}) => {
  const [isPlanValid, setIsPlanValid] = useState(false)
  const [isPhoneNumberValid, setIsPhoneNumberValid] = useState(false)

  const [benefits, setBenefits] = useState<IPatientData['benefits']>([])
  const [jenisPerawatan, setJenisPerawatan] = useState<string>('')
  const [tanggalRencanaPerawatan, setTanggalRencanaPerawatan] = useState<string>('')
  const [tanggalPerawatan, setTanggalPerawatan] = useState<string>('')
  const [indate, setIndate] = useState<string>('')
  const [isBenefitsValid, setIsBenefitsValid] = useState(false)
  const [selectedBenefit, setSelectedBenefit] = useState<IPatientData['benefits'][0] | null>(null)
  const [isTreatmentTypeValid, setIsTreatmentTypeValid] = useState(true)
  const [isIndateValid, setIsIndateValid] = useState(true)
  const [hasOpenedDropdown, setHasOpenedDropdown] = useState(false)

  const [formErrors, setFormErrors] = useState({
    jenisPerawatan: '',
    tanggalRencanaPerawatan: '',
    tanggalPerawatan: '',
    indate: '',
  })

  useEffect(() => {
    if (data.appBasic.memberData && data.appBasic.memberData.benefits) {
      setBenefits(data.appBasic.memberData.benefits)
    }

    // Initialize treatment type to 'Rawat inap' by default if not already set
    if (!data.appBasic.treatmentType) {
      updateData({
        appBasic: {
          ...data.appBasic,
          treatmentType: 'Rawat inap',
        },
      })
      setIsTreatmentTypeValid(true)
    }

    // Set current date for indate if treatment type is 'Rawat jalan'
    if (data.appBasic.treatmentType === 'Rawat jalan') {
      const currentDate = new Date().toISOString().split('T')[0] // Format: YYYY-MM-DD
      updateData({
        appBasic: {
          ...data.appBasic,
          indate: currentDate,
        },
      })
    }
  }, [data.appBasic.memberData, data.appBasic.treatmentType])

  useEffect(() => {
    const validateForm = () => {
      const errors = {
        jenisPerawatan: '',
        tanggalRencanaPerawatan: '',
        tanggalPerawatan: '',
        indate: '',
      }

      let isValid = true

      if (!jenisPerawatan) {
        errors.jenisPerawatan = 'Jenis Perawatan wajib dipilih'
        isValid = false
      }

      if (jenisPerawatan === 'Perawatan Auth') {
        if (!tanggalRencanaPerawatan) {
          errors.tanggalRencanaPerawatan =
            'Tanggal Rencana Perawatan wajib diisi untuk Perawatan Auth'
          isValid = false
        }
      } else if (jenisPerawatan === 'Perawatan Non-Auth') {
        if (!indate) {
          errors.tanggalPerawatan = 'Tanggal Perawatan wajib diisi untuk Perawatan Non-Auth'
          isValid = false
        }
        // if (!tanggalPerawatan) {
        //   alert('sini 6')
        //   errors.tanggalPerawatan = 'Tanggal Perawatan wajib diisi untuk Perawatan Non-Auth'
        //   isValid = false
        // }
      }

      // Validate indate for Rawat inap and Perawatan Non-Auth
      if (
        data.appBasic.treatmentType === 'Rawat inap' &&
        jenisPerawatan === 'Perawatan Non-Auth' &&
        !indate
      ) {
        errors.indate = 'Tanggal Masuk wajib diisi untuk Rawat inap dengan Perawatan Non-Auth'
        isValid = false
      }

      setFormErrors(errors)

      if (isValid) {
        handleStep6ValidationSuccess?.()
      } else {
        handleStep6ValidationError?.()
      }
    }

    validateForm()
  }, [
    jenisPerawatan,
    tanggalRencanaPerawatan,
    tanggalPerawatan,
    indate,
    data.appBasic.treatmentType,
    handleStep6ValidationSuccess,
    handleStep6ValidationError,
  ])

  const handleJenisPerawatanChange = (value: 'Perawatan Auth' | 'Perawatan Non-Auth') => {
    setJenisPerawatan(value)
    const updatedAppBasic = {...data.appBasic, jenisPerawatan: value}
    updateData({...data, appBasic: updatedAppBasic})
  }

  const handleTanggalRencanaPerawatanChange = (date: string) => {
    setTanggalRencanaPerawatan(date)
    const updatedAppBasic = {...data.appBasic, tanggalRencanaPerawatan: date}
    updateData({...data, appBasic: updatedAppBasic})
  }

  // const handleTanggalPerawatanChange = (date: string) => {
  //   setTanggalPerawatan(date)
  //   const updatedAppBasic = {...data.appBasic, tanggalPerawatan: date}
  //   updateData({...data, appBasic: updatedAppBasic})
  // }

  const handleIndateChange = (date: string) => {
    setIndate(date)
    // Update the indate in the main data object
    const updatedData = {
      ...data,
      appBasic: {
        ...data.appBasic,
        indate: date,
      },
    }
    updateData(updatedData)
  }

  const handleBenefitChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const benefitId = e.target.value

    // Check if the selected value is not the default placeholder
    if (benefitId) {
      const selected = benefits.find((benefit) => benefit.id === parseInt(benefitId))
      setSelectedBenefit(selected || null)

      // Check if the selected benefit allows both treatment types or only outpatient
      const allowsBothTreatmentTypes =
        selected &&
        ['INPATIENT', 'INPATIENT-OUTPATIENT-KHUSUS', 'MATERNITY', 'LIMIT BOOSTER TAHUNAN'].includes(
          selected.benefitName
        )

      // If benefit doesn't allow both treatment types, force set to Rawat jalan
      const treatmentType = allowsBothTreatmentTypes
        ? data.appBasic.treatmentType || 'Rawat inap'
        : 'Rawat jalan'

      console.log('treatmentType', treatmentType)

      updateData({
        appBasic: {
          ...data.appBasic,
          benefitDetail: selected || null,
          benefit: selected ? selected.benefitName : '',
          plan: selected ? selected.planName : '',
          treatmentType: treatmentType,
        },
      })

      // Immediately set benefits as valid since user selected a benefit
      setIsBenefitsValid(true)

      // Validate fields after selection with the selected benefit
      validateFieldsWithBenefit(
        {
          ...data.appBasic,
          benefitDetail: selected || null,
          benefit: selected ? selected.benefitName : '',
          plan: selected ? selected.planName : '',
          treatmentType: treatmentType,
        },
        selected
      )
    } else {
      // Reset selectedBenefit if the default option is selected
      setSelectedBenefit(null)
      setIsBenefitsValid(false)
      updateData({
        appBasic: {
          ...data.appBasic,
          benefitDetail: null,
          benefit: '',
          plan: '',
        },
      })
    }
  }

  const validateFields = (appBasicData: typeof data.appBasic) => {
    const planValid = !!appBasicData.plan
    const phoneNumberValid = appBasicData.phoneNumber.trim() !== ''
    const benefitsValid = !!selectedBenefit
    const treatmentTypeValid = !!appBasicData.treatmentType

    // Make indate validation conditional on treatment type
    // Only required for "Rawat inap", always valid for "Rawat jalan"
    const indateValid =
      appBasicData.treatmentType === 'Rawat jalan'
        ? true
        : !!(appBasicData.indate && appBasicData.indate.trim() !== '')

    setIsPlanValid(planValid)
    setIsPhoneNumberValid(phoneNumberValid)
    setIsBenefitsValid(benefitsValid)
    setIsTreatmentTypeValid(treatmentTypeValid)
    setIsIndateValid(indateValid)

    // Include indate validation in overall validity check when needed
    const allFieldsValid =
      planValid && phoneNumberValid && benefitsValid && treatmentTypeValid && indateValid

    if (allFieldsValid) {
      handleStep2ValidationSuccess && handleStep2ValidationSuccess()
      console.log('Complete')
    } else {
      handleStep2ValidationError && handleStep2ValidationError()
      console.log('Incomplete')
    }
  }

  const validateFieldsWithBenefit = (
    appBasicData: typeof data.appBasic,
    selectedBenefitParam: any
  ) => {
    const planValid = !!appBasicData.plan
    const phoneNumberValid = appBasicData.phoneNumber.trim() !== ''
    const benefitsValid = !!selectedBenefitParam
    const treatmentTypeValid = !!appBasicData.treatmentType

    // Make indate validation conditional on treatment type
    // Only required for "Rawat inap", always valid for "Rawat jalan"
    const indateValid =
      appBasicData.treatmentType === 'Rawat jalan'
        ? true
        : !!(appBasicData.indate && appBasicData.indate.trim() !== '')

    setIsPlanValid(planValid)
    setIsPhoneNumberValid(phoneNumberValid)
    setIsBenefitsValid(benefitsValid)
    setIsTreatmentTypeValid(treatmentTypeValid)
    setIsIndateValid(indateValid)

    // Include indate validation in overall validity check when needed
    const allFieldsValid =
      planValid && phoneNumberValid && benefitsValid && treatmentTypeValid && indateValid

    if (allFieldsValid) {
      handleStep2ValidationSuccess && handleStep2ValidationSuccess()
      console.log('Complete')
    } else {
      handleStep2ValidationError && handleStep2ValidationError()
      console.log('Incomplete')
    }
  }

  const handleInputChange = (field: string, value: string) => {
    // Special handling for treatment type
    if (field === 'treatmentType') {
      const updatedData = {
        appBasic: {
          ...data.appBasic,
          [field]: value,
        },
      }

      // If switching to "Rawat inap", reset the indate value
      if (value === 'Rawat inap') {
        updatedData.appBasic.indate = '' // Reset indate when Rawat inap is selected
      }
      // If switching to "Rawat jalan", set indate to current date
      else if (value === 'Rawat jalan') {
        const currentDate = new Date().toISOString().split('T')[0] // Format: YYYY-MM-DD
        updatedData.appBasic.indate = currentDate
      }

      updateData(updatedData)
      validateFields(updatedData.appBasic)
    }
    // Regular field handling for other fields
    else {
      const updatedData = {
        appBasic: {
          ...data.appBasic,
          [field]: value,
        },
      }

      updateData(updatedData)
      validateFields(updatedData.appBasic)
    }
  }

  const handleDropdownOpen = () => {
    setHasOpenedDropdown(true)
  }

  // Initialize values from data
  useEffect(() => {
    if (data.appBasic.jenisPerawatan) {
      setJenisPerawatan(data.appBasic.jenisPerawatan)
    }

    if (data.appBasic.tanggalRencanaPerawatan) {
      setTanggalRencanaPerawatan(data.appBasic.tanggalRencanaPerawatan)
    }

    if (data.appBasic.tanggalPerawatan) {
      setTanggalPerawatan(data.appBasic.tanggalPerawatan)
    }

    if (data.appBasic.indate) {
      setIndate(data.appBasic.indate)
    }
  }, [data.appBasic])

  return (
    <div className='pb-5' data-kt-stepper-element='content'>
      <div className='w-100'>
        {/* Begin::Form Group for Jenis Perawatan */}
        <div className='fv-row mb-10'>
          <label
            className='d-flex align-items-center fs-5 fw-semibold mb-2'
            style={{color: '#6E7191'}}
          >
            <span className='ms-2'>Jenis Perawatan</span>
            <span style={{color: '#059BB6'}}> *</span>
          </label>
          <div className='d-flex'>
            <div className='form-check form-check-custom me-5'>
              <input
                className='form-check-input'
                type='radio'
                name='jenisPerawatan'
                id='perawatanAuth'
                checked={jenisPerawatan === 'Perawatan Auth'}
                onChange={() => handleJenisPerawatanChange('Perawatan Auth')}
              />
              <label
                className='form-check-label'
                htmlFor='perawatanAuth'
                style={{color: '#6E7191'}}
              >
                Perawatan Pre-Auth
              </label>
            </div>
            <div className='form-check form-check-custom'>
              <input
                className='form-check-input'
                type='radio'
                name='jenisPerawatan'
                id='perawatanNonAuth'
                checked={jenisPerawatan === 'Perawatan Non-Auth'}
                onChange={() => handleJenisPerawatanChange('Perawatan Non-Auth')}
              />
              <label
                className='form-check-label'
                htmlFor='perawatanNonAuth'
                style={{color: '#6E7191'}}
              >
                Perawatan Non Pre-Auth
              </label>
            </div>
          </div>
          {formErrors.jenisPerawatan && (
            <div className='invalid-feedback d-block'>{formErrors.jenisPerawatan}</div>
          )}
        </div>
        {/* End::Form Group */}

        {/* Begin::Form Group for Tanggal Rencana Perawatan */}
        <CustomCalendar
          className='mb-10'
          value={tanggalRencanaPerawatan}
          onChange={handleTanggalRencanaPerawatanChange}
          label={
            <span>
              Tanggal Rencana Perawatan
              {jenisPerawatan === 'Perawatan Auth' && <span style={{color: '#059BB6'}}> *</span>}
            </span>
          }
          placeholder='Pilih Tanggal Rencana Perawatan'
          error={formErrors.tanggalRencanaPerawatan || undefined}
        />

        {/* Begin::Form Group for Tanggal Masuk (Indate) */}
        {data.appBasic.treatmentType === 'Rawat inap' && (
          <CustomCalendar
            className='mb-10'
            value={indate}
            onChange={handleIndateChange}
            label={
              <span>
                Tanggal Masuk
                <span style={{color: '#059BB6'}}> *</span>
              </span>
            }
            placeholder='Pilih Tanggal Masuk'
            error={formErrors.indate || undefined}
          />
        )}

        <div className='fv-row mb-10'>
          <label
            className='d-flex align-items-center fs-5 fw-semibold mb-2'
            style={{color: '#6E7191'}}
          >
            <span className='ms-2'>Manfaat </span>
            <span style={{color: '#059BB6'}}> * </span>
          </label>
          <select
            className={`form-select form-select-lg ${!isBenefitsValid ? 'is-invalid' : ''}`}
            value={selectedBenefit ? selectedBenefit.id : ''}
            onChange={handleBenefitChange}
            onFocus={handleDropdownOpen}
          >
            <option value='' disabled>
              Select Benefit
            </option>
            {benefits.map((benefit) => (
              <option key={benefit.id} value={benefit.id}>
                {benefit.benefitName}
              </option>
            ))}
          </select>
          {errorMessageBenefit && (
            <div
              className='mt-4'
              style={{
                border: '1px solid #F15E60',
                borderRadius: '6px',
                padding: '10px',
                backgroundColor: '#FFFFFF',
              }}
            >
              <div
                className='d-flex align-items-center'
                style={{color: '#F15E60', fontWeight: 'bold'}}
              >
                <KTIcon iconName='cross-circle' className='me-2 custom-red large-icon' />
                Pasien
              </div>
              <hr style={{border: '1px solid #F15E60', margin: '10px 0'}} />
              <div style={{color: '#333'}}>
                <span style={{color: '#b2b7bf'}}>{data.appBasic.cardNumber}</span>{' '}
                {errorMessageBenefit}
              </div>
            </div>
          )}
        </div>
        <div className='fv-row mb-10'>
          <label
            className='d-flex align-items-center fs-5 fw-semibold mb-2'
            style={{color: '#6E7191'}}
          >
            <span className='ms-2'>Tipe Perawatan</span>
            <span style={{color: '#059BB6'}}> *</span>
          </label>
          <div className='d-flex'>
            <div className='form-check form-check-custom me-5'>
              <input
                className='form-check-input'
                type='radio'
                name='treatmentType'
                id='treatmentTypeInpatient'
                checked={data.appBasic.treatmentType === 'Rawat inap'}
                onChange={() => handleInputChange('treatmentType', 'Rawat inap')}
                disabled={
                  !!selectedBenefit &&
                  ![
                    'INPATIENT',
                    'INPATIENT-OUTPATIENT-KHUSUS',
                    'MATERNITY',
                    'LIMIT BOOSTER TAHUNAN',
                    // 'OUTPATIENT',
                  ].includes(data?.appBasic?.benefit)
                  // ].includes(data?.appBasic?.memberData?.insurerCode)
                }
              />
              <label
                className='form-check-label'
                htmlFor='treatmentTypeInpatient'
                style={{color: '#6E7191'}}
              >
                Rawat inap
              </label>
            </div>
            {/* <div className='form-check form-check-custom'>
              <input
                className='form-check-input'
                type='radio'
                name='treatmentType'
                id='treatmentTypeOutpatient'
                checked={data.appBasic.treatmentType === 'Rawat jalan'}
                onChange={() => handleInputChange('treatmentType', 'Rawat jalan')}
                disabled={[
                  '22110009',
                  'PDL',
                  'ALLISYA',
                  // 'AFI',
                  'ALLIANZ',
                  'CHUI',
                  'JD',
                  'AAL',
                  'FWDII',
                  'EQI',
                  'AXM',
                ].includes(data?.appBasic?.memberData?.insurerCode)}
              />
              <label
                className='form-check-label'
                htmlFor='treatmentTypeOutpatient'
                style={{color: '#6E7191'}}
              >
                Rawat jalan
              </label>
            </div> */}
          </div>
          {!isTreatmentTypeValid && (
            <div className='invalid-feedback d-block'>Tipe Perawatan wajib dipilih.</div>
          )}
        </div>
        <div className='fv-row mb-10'>
          <label
            className='d-flex align-items-center fs-5 fw-semibold mb-2'
            style={{color: '#6E7191'}}
          >
            <span className='ms-2'>Plan Peserta</span>
            <span style={{color: '#059BB6'}}> *</span>
          </label>
          <input
            type='text'
            className={`form-control form-control-lg  ${!isPlanValid ? 'is-invalid' : ''}`}
            placeholder='IP 100'
            value={data.appBasic.plan || (selectedBenefit ? selectedBenefit.planName : '')}
            onChange={(e) => handleInputChange('plan', e.target.value)}
            readOnly={true}
            style={{backgroundColor: '#F5F8FA', cursor: 'not-allowed'}}
          />
          {/* Error Message Display */}
          {errorMessageProduct && (
            <div
              className='mt-4'
              style={{
                border: '1px solid #F15E60',
                borderRadius: '6px',
                padding: '10px',
                backgroundColor: '#FFFFFF',
              }}
            >
              <div
                className='d-flex align-items-center'
                style={{color: '#F15E60', fontWeight: 'bold'}}
              >
                <KTIcon iconName='cross-circle' className='me-2 custom-red large-icon' />
                Pasien
              </div>
              <hr style={{border: '1px solid #F15E60', margin: '10px 0'}} />
              <div style={{color: '#333'}}>
                <span style={{color: '#b2b7bf'}}>{data.appBasic.cardNumber}</span>{' '}
                {errorMessageProduct}
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  )
}

export {Step6}
